import { render, staticRenderFns } from "./dataCenterEnergy.vue?vue&type=template&id=ec08b78c&scoped=true&"
import script from "./dataCenterEnergy.vue?vue&type=script&lang=js&"
export * from "./dataCenterEnergy.vue?vue&type=script&lang=js&"
import style0 from "./dataCenterEnergy.vue?vue&type=style&index=0&id=ec08b78c&scoped=true&lang=css&"
import style1 from "./dataCenterEnergy.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec08b78c",
  null
  
)

export default component.exports